module.exports = {"interface":[{"constant":false,"inputs":[],"name":"clear","outputs":[],"payable":false,"type":"function"},{"inputs":[{"name":"token","type":"address"}],"payable":false,"type":"constructor"}]}


//////////////////
// WEBPACK FOOTER
// ./src/contracts/abi/token-wrapper/deposit-broker.json
// module id = 855
// module chunks = 0